export const texts = {
  toProject: {
    de: 'Zur Stelle',
    en: 'To the position'
  },
  addNote: {
    de: 'Anmerkung erstellen',
    en: 'Add note'
  },
  startSourcing: {
    de: 'Sourcing starten',
    en: 'Start sourcing'
  }
};
